module.exports = __webpack_public_path__ + "img/img-14.018385cf.png";